import React from "react";
import "./style.css";
import { Col, Container, Row } from "react-bootstrap";

const Footer = () => {
  return (
    <footer>
      <Container>
        <Row className="footer-row gy-4">
          <Col md={3} sm={6} xs={12} className="box">
            <div className="logo">
              <ion-icon name="bag-handle-outline"></ion-icon>
              <h1>Novamart</h1>
            </div>
            <p>
              Novamart is your one-stop shop for the latest and greatest in furniture, fashion, and more. Quality and satisfaction guaranteed.
            </p>
            {/* <div className="social-icons">
              <a href="#!" aria-label="Facebook" target="_blank" rel="noreferrer"><ion-icon name="logo-facebook"></ion-icon></a>
              <a href="#!" aria-label="Twitter" target="_blank" rel="noreferrer"><ion-icon name="logo-twitter"></ion-icon></a>
              <a href="#!" aria-label="Instagram" target="_blank" rel="noreferrer"><ion-icon name="logo-instagram"></ion-icon></a>
              <a href="#!" aria-label="LinkedIn" target="_blank" rel="noreferrer"><ion-icon name="logo-linkedin"></ion-icon></a>
            </div> */}
          </Col>

          <Col md={3} sm={6} xs={12} className="box">
            <h2>About Us</h2>
            <ul>
              <li><a href="#!" tabIndex={0}>Careers</a></li>
              <li><a href="#!" tabIndex={0}>Our Stores</a></li>
              <li><a href="#!" tabIndex={0}>Our Values</a></li>
              <li><a href="#!" tabIndex={0}>Terms & Conditions</a></li>
              <li><a href="#!" tabIndex={0}>Privacy Policy</a></li>
            </ul>
          </Col>

          <Col md={3} sm={6} xs={12} className="box">
            <h2>Customer Care</h2>
            <ul>
              <li><a href="#!" tabIndex={0}>Help Center</a></li>
              <li><a href="#!" tabIndex={0}>How to Buy</a></li>
              <li><a href="#!" tabIndex={0}>Track Your Order</a></li>
              <li><a href="#!" tabIndex={0}>Corporate & Bulk Purchasing</a></li>
              <li><a href="#!" tabIndex={0}>Returns & Refunds</a></li>
            </ul>
          </Col>

          <Col md={3} sm={6} xs={12} className="box">
            <h2>Contact Us</h2>
            <ul>
              <li>1839 Snead st Bolingbrook , Illinois 60490 , United States</li>
              <li>Email: info@novamart.com</li>
              <li>Phone: (480) 787-0039</li>
              <li>Mon - Fri: 9:00 AM - 6:00 PM</li>
            </ul>
          </Col>
        </Row>
        <Row className="footer-bottom mt-5 pt-3">
          <Col className="text-center">
            <p>© 2022 Novamart. All rights reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
